import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAirConditioning = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0v4.793L14.646.646l.708.708L10.5 6.207V9.5h3.292l4.854-4.854.708.708L15.206 9.5H20v1h-4.794l4.148 4.146-.708.708-4.854-4.854H10.5v3.292l4.854 4.854-.708.708-4.146-4.148V20h-1v-4.794l-4.146 4.148-.708-.708L9.5 13.792V10.5H6.207l-4.853 4.854-.708-.708L4.792 10.5H0v-1h4.792L.646 5.354l.708-.708L6.207 9.5H9.5V6.207L4.646 1.354l.708-.708L9.5 4.793V0h1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgAirConditioning;